module.exports = __webpack_public_path__ + "static/media/29BDOS14.0c7e5b4c.jpg";